import type { DynamicFilterDataType } from "app/pages/sales-intelligence/domain/search/types/dynamic-filter-options";
import type { DynamicFilterMetadata } from "app/pages/sales-intelligence/domain/search/types/dynamic-filter-values";

import type {
    DynamicComboboxFilterOptions,
    DynamicNumberRangeOptions,
    DynamicRelativeDateRangeOptions,
} from "./filterOptions";

export const dynamicFilterWidgetMap = {
    enumCombobox: "enumCombobox",
    enumArrayCombobox: "enumArrayCombobox",
    relativeDateRange: "relativeDateRange",
    numberRange: "numberRange",
} as const;

export type DynamicFieldDescriptor =
    | {
          readonly key: string;
          readonly widget: "enumCombobox";
          readonly dataType: DynamicFilterDataType;
          readonly options: DynamicComboboxFilterOptions;
          readonly metadata?: DynamicFilterMetadata;
      }
    | {
          readonly key: string;
          readonly widget: "enumArrayCombobox";
          readonly dataType: DynamicFilterDataType;
          readonly options: DynamicComboboxFilterOptions;
          readonly metadata?: DynamicFilterMetadata;
      }
    | {
          readonly key: string;
          readonly widget: "relativeDateRange";
          readonly dataType: DynamicFilterDataType;
          readonly options: DynamicRelativeDateRangeOptions;
          readonly metadata?: DynamicFilterMetadata;
      }
    | {
          readonly key: string;
          readonly widget: "numberRange";
          readonly dataType: DynamicFilterDataType;
          readonly options: DynamicNumberRangeOptions;
          readonly metadata?: DynamicFilterMetadata;
      };
